<template>
    <ConfirmDialog group="dialog" />
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-fluid">
                <!-- <h4>
                    <strong>{{ $t('PositionOffer.View.Application_Details') }}</strong>
                </h4> -->
                <div class="p-field p-grid">
                    <label for="name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.CompanyName') }} :</label>
                    <div class="p-col-12 p-md-4">
                        <p>{{ job_info.company_name }}</p>
                    </div>
                    <label for="name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.WorkType') }} :</label>
                    <div class="p-col-12 p-md-2">
                        <span v-if="job_info.working_mode === 'full_time'">{{ $t('full_time') }}</span>
                        <span v-else-if="job_info.working_mode === 'contract_worker'">{{ $t('contract_worker') }}</span>
                        <span v-else-if="job_info.working_mode === 'part_time_job'">{{ $t('part_time_job') }}</span>
                        <span v-else-if="job_info.working_mode === 'dispatch'">{{ $t('dispatch') }}</span>
                        <span v-else-if="job_info.working_mode === 'internship'">{{ $t('internship') }}</span>
                        <span v-else-if="job_info.working_mode === 'freelancer'">{{ $t('freelancer') }}</span>
                        <span v-else-if="job_info.working_mode === 'etc'">{{ $t('etc') }}</span>
                        <span>(수습기간 {{ job_info.probation }} 개월)</span>
                        <!-- <p>{{ job_info.working_mode }}</p> -->
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="name_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.ManagerE-Mail') }} :</label>
                    <div class="p-col-12 p-md-4">
                        <p>{{ job_info.contact_email }}</p>
                    </div>
                    <label for="name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.WorkArea') }} :</label>
                    <div class="p-col-12 p-md-2">
                        <p>{{ job_info.workarea_address }}</p>
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.JobPost') }} :</label>
                    <div class="p-col-12 p-md-4">
                        <p>{{ job_info.announcement_title }}</p>
                    </div>
                    <label for="name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.Career') }} :</label>
                    <div class="p-col-12 p-md-2">
                        <p>{{ $t(job_info.career) }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="name_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.JobType') }} :</label>
                    <div class="p-col-12 p-md-4">
                        <p>
                            <b>{{ job_occupation_info }}</b>
                        </p>
                    </div>
                    <label for="name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" id="fonts">{{ $t('PositionOffer.View.Wages') }} :</label>
                    <div class="p-col-12 p-md-2">
                        <p>
                            <span v-if="job_info.pay_type == 'daily_wage'">{{ $t('daily_wage') }}</span
                            ><span v-else-if="job_info.pay_type == 'hourly_wage'">{{ $t('hourly_wage') }}</span
                            ><span v-else-if="job_info.pay_type == 'salary'">{{ $t('salary') }}</span> &nbsp;{{ job_info.salary === null ? '---' : formatSalary(job_info.salary) + '&nbsp;' + '원' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-pb-0">
                <div class="p-d-flex p-jc-end p-mb-2">
                    <!-- <h4>{{ $t('PositionOffer.View.Applicants_List') }}</h4> -->
                    <div>
                        <div style="display: flex; float: right; margin-bottom: 10px">
                            <label id="sts">{{ $t('PositionOffer.View.Status') }}</label> &nbsp;&nbsp;&nbsp;
                            <Dropdown v-model="filterStatusData" :options="filterStatusValue" optionValue="value" optionLabel="label" :placeholder="$t('MemberStatistic.list.Select')" @change="sortingOrdering(filterStatusData, 'filter')" />
                            &nbsp;&nbsp;&nbsp;

                            <Dropdown v-model="sortBy" :options="sort_by" optionValue="value" optionLabel="label" :placeholder="$t('MemberStatistic.list.Select')" @change="sortingOrdering(sortBy, 'name')" />
                            &nbsp;&nbsp;&nbsp;
                            <Dropdown v-model="sortOrder" :options="sort_order" optionValue="value" optionLabel="label" :placeholder="$t('MemberStatistic.list.Select')" @change="sortingOrdering(sortOrder, 'sorting')" />
                        </div>
                    </div>
                </div>

                <DataTable :value="UserData" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="user_id" :rowHover="true" :loading="loading" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <Column field="#" :header="$t('PositionOffer.View.No')" style="width: 1rem">
                        <template #body="{ index }">
                            <span class="p-column-title">Sl. No.</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <column selectionMode="multiple" he style="width: 16px; text-align: center">
                        <!-- <template #body="{ data }">
                            <Checkbox inputId="binary" v-model="data.checked" :binary="true" :disabled="data.is_offered == '1'" :readonly="data.is_offered == '1'" @input="getID(data.checked, data.user_id)" />
                        </template> -->
                    </column>
                    <Column field="name" :header="$t('PositionOffer.View.JobSeeker')" style="width: 13rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Applicant ID</span>
                            <span v-if="data.memo_info === null">
                                <router-link :to="'/PositionOffer/JobSeekerDetails/' + data.seeker_id" style="color: black">
                                    {{ data.name }}
                                </router-link>
                            </span>
                            <span v-else-if="data.memo_info === ''">
                                <router-link :to="'/PositionOffer/JobSeekerDetails/' + data.seeker_id" style="color: black">
                                    {{ data.name }}
                                </router-link>
                            </span>
                            <span v-else>
                                <router-link :to="'/PositionOffer/JobSeekerDetails/' + data.seeker_id" style="color: red">
                                    {{ data.name }}
                                </router-link>
                            </span>
                        </template>
                    </Column>
                    <Column field="status" :header="$t('PositionOffer.View.Status')" style="width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>
                            <p id="round" style="border-radius: 12px; display: inline-block; padding: 4px 15px" v-if="data.status === null">{{ data.status === null ? $t('Waiting') : $t(data.status) }}</p>
                            <p id="round" style="border-radius: 12px; border: 1px solid purple; color: purple; display: inline-block; padding: 4px 15px" v-else-if="data.status === 'agree'">
                                {{ data.status === null ? $t('Waiting') : $t(data.status) }}
                            </p>
                            <p id="round" style="border-radius: 12px; border: 1px solid #a4a4a4; color: #a4a4a4; display: inline-block; padding: 4px 15px" v-else-if="data.status === 'declined'">
                                {{ data.status === null ? $t('Waiting') : $t(data.status) }}
                            </p>
                            <p id="round" style="border-radius: 12px; border: 1px solid red; color: red; display: inline-block; padding: 4px 15px" v-else-if="data.status === 'absent'">
                                {{ data.status === null ? $t('Waiting') : $t(data.status) }}
                            </p>
                            <p id="round" style="border-radius: 12px; border: 1px solid green; color: green; display: inline-block; padding: 4px 15px" v-else>{{ data.status === null ? $t('Waiting') : $t(data.status) }}</p>
                        </template>
                    </Column>
                    <Column field="ResumeSuggestion" :header="$t('PositionOffer.View.ResumeSuggestion')" style="width: 30rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>

                            <Button :label="$t('PositionOffer.View.Agreed')" class="p-button2 p-mr-2" @click="Agreed(data.seeker_id, $route.params.id, data.resume_id, 'agree')"> </Button>

                            <Button :label="$t('PositionOffer.View.ResumeSuggestion')" class="p-button2 p-mr-2" @click="openResponsive1(data.seeker_id, $route.params.id, data.resume_id, 'resume_suggestion')"> </Button>

                            <Button :label="$t('PositionOffer.View.Absent')" class="p-button2 p-mr-2" @click="Absent(data.seeker_id, $route.params.id, data.resume_id, 'absent')"> </Button>
                            <Button :label="$t('PositionOffer.View.Declined')" class="p-button2 p-mr-2" @click="Declined(data.seeker_id, $route.params.id, data.resume_id, 'declined')"> </Button>
                        </template>
                    </Column>

                    <Column field="Actions" :header="$t('PositionOffer.View.PositionSuggestion')" style="width: 18rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Actions</span>
                            <p style="display: none">{{ data.status }}</p>
                            <div style="display: flex">
                                <span v-if="data.is_offered === 1">
                                    <Button :label="$t('PositionOffer.View.PositionSuggestion')" class="p-button p-mr-2" disabled style="border-color: gray; color: black; background-color: gray"></Button>
                                </span>
                                <span v-else>
                                    <Button :label="$t('PositionOffer.View.PositionSuggestion')" class="p-button2 p-mr-2" @click="openResponsive2($route.params.id, data.user_id)"> </Button>
                                </span>
                                <!-- <Button :label="$t('button.delete')" icon="pi pi-trash" class="n-wrap p-button-danger p-button-outlined p-mr-2 p-mb-2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>

                <div class="p-d-flex p-jc-end" style="float: left">
                    <Button :label="$t('PositionOffer.View.Send')" icon="pi pi-send" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="openResponsive" style="background: black; color: white"></Button>
                </div>

                <div class="p-d-flex p-jc-end p-ai-center">
                    <div>
                        <Button :label="$t('Service.Edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="stepback()" style="background: white; color: black"> </Button>
                    </div>
                </div>
                <small class="info">{{ $t('PositionOffer.View.RecommendInfo') }}</small>
            </div>
        </div>
    </div>

    <!-- <div class="p-d-flex p-jc-end" style="float: left">

        <router-link :to="'/VoteManagementEdit/' + $route.params.id"><Button label="help"
                class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2"><i class="pi pi-user-edit p-mr-2"></i>
                Edit </Button></router-link>
         <Button @click="del($route.params.id)" label="delete" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"><i class="pi pi-trash p-mr-2"></i>{{$t('button.delete')}}</Button>
    </div> -->

    <Dialog modal :header="$t('Recommendation')" v-model:visible="displayResponsive" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '18vw' }">
        <!-- <p class="text-choose"><b>{{ $t('Free1.View.ReasonSelect') }}</b></p> -->
        <div class="p-col-12 p-md-12 p-pt-5" id="reason">
            <p id="modex">{{ $t('PositionOffer.View.ModalText') }}</p>
            <p id="modex">{{ $t('PositionOffer.View.ModalText1') }}</p>
            <p id="modex1">{{ $t('PositionOffer.View.ModalText2') }}</p>
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('PositionOffer.View.Ok')" icon="pi pi-check" id="save" @click="RecommendationAll($route.params.id, user_id)" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('PositionOffer.View.Cancel')" icon="pi pi-times" @click="closeResponsive" class="p-button p-button p-button-outlined" id="close" />
            </div>
        </template>
    </Dialog>
    <Dialog modal :header="$t('Recommendation')" v-model:visible="displayResponsive2" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '18vw' }">
        <!-- <p class="text-choose"><b>{{ $t('Free1.View.ReasonSelect') }}</b></p> -->
        <div class="p-col-12 p-md-12 p-pt-5" id="reason">
            <p id="modex">{{ $t('PositionOffer.View.ModalText') }}</p>
            <p id="modex">{{ $t('PositionOffer.View.ModalText1') }}</p>
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('PositionOffer.View.Ok')" icon="pi pi-check" id="save" @click="Recommendation($route.params.id, users_id)" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('PositionOffer.View.Cancel')" icon="pi pi-times" @click="closeResponsive2" class="p-button p-button p-button-outlined" id="close" />
            </div>
        </template>
    </Dialog>
    <Dialog modal :header="$t('ResumeSuggestion')" v-model:visible="displayResponsive1" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '18vw' }">
        <!-- <p class="text-choose"><b>{{ $t('Free1.View.ReasonSelect') }}</b></p> -->
        <div class="p-col-12 p-md-12 p-pt-5" id="reason">
            <p id="modex">{{ $t('PositionOffer.View.ResumeModlText') }}</p>
            <p id="modex">{{ $t('PositionOffer.View.ResumeModlText1') }}</p>
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('PositionOffer.View.Ok')" icon="pi pi-check" id="save" @click="ResumeSuggest(seeker_id, $route.params.id, resume_id, 'resume_suggestion')" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('PositionOffer.View.Cancel')" icon="pi pi-times" @click="closeResponsive1" class="p-button p-button p-button-outlined" id="close" />
            </div>
        </template>
    </Dialog>
</template>

<script>
import axios from 'axios';
import PositionOfferService from '../../service/API/PositionOfferService';
import utils from '@/service/utils';
// import ValidateSendPosition from '../../validations/PositionOffer/ValidateSendPosition';
// import {useRouter} from 'vue-router'
import Swal from 'sweetalert2';
import moment from 'moment';
export default {
    name: 'PositionOffered',
    data() {
        return {
            dropdownGenderValues: [
                { name: '남성', value: 'm' },
                { name: '여성', value: 'f' },
            ],
            dropdownGenderValue: null,
            dropdownAppStatusValues: [
                { name: 'Pending', value: '2' },
                { name: 'Approve', value: '1' },
                { name: 'Rejected', value: '0' },
            ],
            dropdownAppStatusValue: null,
            title: '',
            country_id: '',
            max_user_apply: '',
            image: '',
            description: '',
            status: '',
            selectedApplicantCount: '',
            applicantCount: '',

            dropdownCountryValues: '',
            dropdownCountryValue: null,
            name: '',
            email: '',
            UserData: [],
            selected: [],
            displayResponsive: false,
            isModalVisible: false,
            displayResponsive1: false,
            displayResponsive2: false,
            isModalVisible1: false,
            serial_no: '',
            application_status: '',
            is_shortlisted: '',
            checked: true,
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            filterStatusValue: [
                { value: '', label: '모두' },
                { value: 'waiting', label: '대기중' },
                { value: 'agree', label: '동의' },
                { value: 'resume_suggestion', label: '완료' },
                { value: 'decline', label: '거절' },
                { value: 'absent', label: '부재중' },
            ],
            sortBy: '',
            filterStatusData: '',
            sort_order: [
                { value: 'asc', label: '오름차순' },
                { value: 'desc', label: '내림차순' },
            ],
            sortOrder: '',
            sort_by: [{ value: 'name', label: '이름' }],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },

            job_info: {
                id: '',
                employer_id: '',
                contact_name: '',
                is_private_name: '',
                contact_person_num: '',
                is_private_person_num: '',
                contact_email: '',
                is_private_email: '',
                workarea_code: '',
                workarea_address: '',
                is_private_address: '',
                gender: '',
                age: '',
                mid_age_value: '',
                start_age: '',
                end_age: '',
                region_1st_depth: '',
                region_2nd_depth: '',
                region_3rd_depth: '',
                education: '',
                areas_of_recruitment: '',
                num_of_recruitment: '',
                is_num_of_recruitment_undecided: '',
                responsibilities: '',
                eligibilities: '',
                career: '',
                min_experience: '',
                max_experience: '',
                any_experience: '',
                working_mode: '',
                working_hour_from: '',
                working_hour_end: '',
                break_time_from: '',
                break_time_end: '',
                no_break_time: '',
                probation: '',
                working_period: '',
                negotiable_working_period: '',
                negotiable_working_days: '',
                status: '',
                prescribed_working_hours: '',
                pay_type: '',
                salary: '',
                converted_salary: '',
                announcement_title: '',
                notice_posting_period: '',
                notice_posting_period_custom_start_date: '',
                notice_posting_period_custom_end_date: '',
                admin_approved: '',
                reason: '',
                last_upgle_time: '',
                filter_time: '',
                created_at: '',
                updated_at: '',
                job_latitude: '',
                job_longtitude: '',
                industry_name: '',
                employer_rating: '',
                name: '',
                company_name: '',
                company_profile_img: '',
                business_address: '',
                industry: '',
                no_of_emp: '',
                region_1st_depth_name: '',
                region_2nd_depth_name: '',
                region_3rd_depth_name: '',
                lat: '',
                long: '',
            },
            error: {},
            SearchValue: '',
            type: '',
            job_occupation_info: '',
            loading: false,
        };
    },
    created() {
        this.positionOfferService = new PositionOfferService();
    },

    mounted() {
        // this.getUserLists(this.$route.params.id);
        let SearchParams = JSON.parse(localStorage.getItem('SearchParams'));
        console.log('ValueSearch', SearchParams);
        console.log('currpath', this.$route.name);
        localStorage.setItem('prev_offered_path', this.$route.name);
        this.SearchValue = {
            page: 1,
            limit: 10,
            jobId: this.$route.params.id,
            occupation_first: SearchParams.occupation_first.toString(),
            occupation_second: SearchParams.occupation_second.toString(),
            occupation_third: SearchParams.occupation_third.toString(),
            sortOrder: this.sortOrder,
            filterStatus: this.filterStatusData,
            sortBy: this.sortBy,
        };
        this.positionOfferService.viewPositionOffers(this.SearchValue).then((res) => {
            this.job_info.company_name = res.data.job_info.company_name;
            this.job_info.announcement_title = res.data.job_info.announcement_title;
            this.job_info.contact_email = res.data.job_info.contact_email;
            this.job_info.industry_name = res.data.job_info.industry_name;
            this.job_info.working_mode = res.data.job_info.working_mode;
            this.job_info.workarea_address = res.data.job_info.workarea_address;
            this.job_info.career = res.data.job_info.career;
            this.job_info.pay_type = res.data.job_info.pay_type;
            this.job_info.converted_salary = res.data.job_info.converted_salary;
            this.job_occupation_info = res.data.job_occupation_info;
            this.job_info.probation = res.data.job_info.probation;
            this.job_info.salary = res.data.job_info.salary;
            console.log(res);
            // console.log(this.$route.params.id);
            this.getUserLists(this.SearchValue);
        });
    },
    methods: {
        formatSalary(value) {
            // Convert the value to a string and add comma separators
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        stepback() {
            this.$router.go(-1);
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading = true;
            this.SearchValue.page = page;
            this.positionOfferService
                .viewPositionOffers(this.SearchValue)
                .then((res) => {
                    this.UserData = res.data.data;
                    this.pagination.current_page = page;
                    this.loading = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        startdateformat(value) {
            if (value) {
                return moment.utc(value).format('YYYY/MM/DD HH:mm:ss');
            }
        },
        Regdateformat(value) {
            if (value) {
                // return moment(String(value)).format('YYYY/MM/DD ');
                return moment(String(value)).locale('ko').format('ll');
            }
        },
        formatRangeDate(date) {
            if (date === undefined || date === '') {
                return '';
            }
            return moment(new Date(date)).format('YYYY-MM-DD');
        },
        UTCdateformat(value) {
            if (value) {
                return moment.utc(value).locale('ko').format('ll - LTS');
            }
        },
        openResponsive() {
            this.displayResponsive = true;
        },
        closeResponsive() {
            this.displayResponsive = false;
        },
        openResponsive2(job_id, user_id) {
            this.displayResponsive2 = true;
            this.users_id = user_id;
            this.job_id = job_id;
            // alert(this.users_id);
        },
        closeResponsive2() {
            this.displayResponsive2 = false;
        },
        openResponsive1(seeker_id, id, resume_id) {
            this.displayResponsive1 = true;
            this.seeker_id = seeker_id;
            this.resume_id = resume_id;
            this.id = id;
        },
        closeResponsive1() {
            this.displayResponsive1 = false;
        },
        getID(e, v) {
            console.log(e, v);
            if (e === true) {
                this.selected.push(v);
            } else {
                const index = this.selected.indexOf(v);
                if (index > -1) {
                    // only splice array when item is found
                    this.selected.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
            // console.log(this.selected);
        },
        Agreed(seeker_id, job_id, resume_id, status) {
            var self = this;
            axios({ method: 'post', url: 'api/v1/admin/position-offer/set-resume-recommendation', data: { seeker_id: seeker_id.toString(), job_id: job_id, resume_id: resume_id.toString(), status: status } })
                .then(function (response) {
                    console.log(response);

                    self.$toast.add({ severity: 'info', summary: '확인.', detail: '동의 처리 되었습니다.', life: 3000 });
                    // self.getUserLists(this.SearchValue);
                    // window.location.reload();
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    console.log(response);
                })
                .catch(function (err) {
                    if (err.response.data.error === 'Job Seeker Resume Has Been Already Sent To Recruiter') {
                        Swal.fire({
                            title: '에러 메시지',
                            text: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다',
                            icon: 'error',
                            confirmButtonText: '확인',
                        });
                        // self.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다.', life: 3000 });
                        // window.location.reload();
                    }
                });
        },
        Absent(seeker_id, job_id, resume_id, status) {
            var self = this;
            axios({ method: 'post', url: 'api/v1/admin/position-offer/set-resume-recommendation', data: { seeker_id: seeker_id.toString(), job_id: job_id, resume_id: resume_id.toString(), status: status } })
                .then(function (response) {
                    // this.$router.push({ name: 'Banner Management' });
                    console.log(response);

                    self.$toast.add({ severity: 'info', summary: '확인.', detail: '부재중 처리 되었습니다.', life: 3000 });
                    // window.location.reload();
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    console.log(response);
                })
                .catch(function (err) {
                    if (err.response.data.error === 'Job Seeker Resume Has Been Already Sent To Recruiter') {
                        Swal.fire({
                            title: '에러 메시지',
                            text: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다',
                            icon: 'error',
                            confirmButtonText: '확인',
                        });
                        // self.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다.', life: 3000 });
                        // window.location.reload();
                    }
                    setTimeout(() => {
                        // window.location.reload();
                    }, 500);
                });
        },
        Declined(seeker_id, job_id, resume_id, status) {
            var self = this;
            axios({ method: 'post', url: 'api/v1/admin/position-offer/set-resume-recommendation', data: { seeker_id: seeker_id.toString(), job_id: job_id, resume_id: resume_id.toString(), status: status } })
                .then(function (response) {
                    // this.$router.push({ name: 'Banner Management' });
                    console.log(response);

                    self.$toast.add({ severity: 'info', summary: '확인.', detail: '거절 처리 되었습니다.', life: 3000 });
                    // window.location.reload();
                    console.log(response);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                })
                .catch(function (err) {
                    if (err.response.data.error === 'Job Seeker Resume Has Been Already Sent To Recruiter') {
                        Swal.fire({
                            title: '에러 메시지',
                            text: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다',
                            icon: 'error',
                            confirmButtonText: '확인',
                        });
                        // self.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다.', life: 3000 });
                        // window.location.reload();
                    }
                    setTimeout(() => {
                        // window.location.reload();
                    }, 500);
                });
        },
        ResumeSuggest(seeker_id, job_id, resume_id, status) {
            // alert(job_id, status);
            var self = this;
            return axios
                .post('api/v1/admin/position-offer/set-resume-recommendation', { seeker_id: seeker_id, job_id: job_id, resume_id: resume_id, status: status })
                .then(function (response) {
                    // axios({ method: 'post', url: 'api/v1/admin/position-offer/set-resume-recommendation',  { seeker_id: seeker_id, job_id: job_id, resume_id: resume_id, status: status } }).then(function (response) {
                    // this.$router.push({ name: 'Banner Management' });
                    console.log(response);

                    self.$toast.add({ severity: 'info', summary: '확인.', detail: '이력서 추천이 완료되었습니다.', life: 3000 });
                    self.displayResponsive1 = false;
                    // window.location.reload();
                    self.loading = false;
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    console.log(response);
                })
                .catch(function (err) {
                    if (err.response.data.error === 'Job Seeker Resume Has Been Already Sent To Recruiter') {
                        // self.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다.', life: 3000 });
                        self.displayResponsive1 = false;
                        Swal.fire({
                            title: '에러 메시지',
                            text: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다',
                            icon: 'error',
                            confirmButtonText: '확인',
                        });
                        // window.location.reload();
                    }
                    setTimeout(() => {
                        // window.location.reload();
                    }, 500);
                });
        },
        Recommendation(job_id, users_id) {
            // alert(users_id);
            var self = this;
            axios({ method: 'post', url: 'api/v1/admin/position-offer/send-offer', data: { job_id: job_id, users_id: [users_id] } }).then(function (response) {
                // this.$router.push({ name: 'Banner Management' });
                console.log(response);
                self.$toast.add({ severity: 'info', summary: '확인.', detail: '포지션이 추천이 완료되었습니다.', life: 3000 });
                self.displayResponsive2 = false;
                // window.location.reload();
                setTimeout(() => {
                    window.location.reload();
                }, 500);
                console.log(response);
            });
        },

        getUserLists(data) {
            // let resultData = data;
            // resultData.map(item=>{

            // })
            // const ApplicantParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            //     jobId: this.$route.params.id,
            //     occupation_first: this.occupation_first,
            //     occupation_second: this.occupation_second,
            //     occupation_third: this.occupation_third,
            //     sortOrder: this.sortOrder,
            //     filterStatus: this.filterStatus,
            // };
            this.loading = true;
            this.positionOfferService
                .viewPositionOffers(data)
                .then((res) => {
                    this.UserData = res.data.data;
                    this.totalrecords = res.data.data.total_records;
                    this.seeker_id = res.data.data.seeker_id;
                    this.resume_id = res.data.data.resume_id;
                    // this.is_shortlisted = res.data.data.is_shortlisted;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);

                    console.log(res);
                    this.loading = false;
                    // console.log(this.Applicants[0].is_shortlisted)
                })
                .catch((err) => console.log(err));
        },
        sortingOrdering(SearchValue, type) {
            console.log(SearchValue);
            if (type === 'filter') {
                this.SearchValue.filterStatus = SearchValue;
            } else if (type === 'sorting') {
                this.SearchValue.sortOrder = SearchValue;
            } else if (type === 'name') {
                this.SearchValue.sortBy = SearchValue;
            }

            this.loading = true;

            // let sortingParams = {
            //     limit: this.pagination.pagination_limit,
            //     page: 1,
            //     // sortBy: this.sortByValue,
            //     sortOrder: this.sortOrder,
            //     filterStatus: this.filterStatus,
            //     // jobId: this.$route.params.id,
            //     occupation_first: this.occupation_first,
            //     occupation_second: this.occupation_second,
            //     occupation_third: this.occupation_third,
            // };
            this.positionOfferService
                .viewPositionOffers(this.SearchValue)
                .then((res) => {
                    this.UserData = res.data.data;
                    this.totalrecords = res.data.data.total_records;
                    // this.is_shortlisted = res.data.data.is_shortlisted;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);

                    console.log(res);
                    this.loading = false;
                    // console.log(this.Applicants[0].is_shortlisted)
                })
                .catch((err) => console.log(err));
        },

        RecommendationAll() {
            // let xyz = [];
            // let data = this.selected;
            let self = this;
            let res_array = this.selected.filter((obj) => obj.is_offered == 0);
            // console.log(res_array);
            let userIds = res_array.map((obj) => obj.user_id);
            // console.log(userIds);
            // for (var a = 0; a < data.length; a++) {
            //     //    xyz.push({ user_id: data[a].id });
            //     xyz.push(data[a].id);
            // }
            // alert(this.selected.length);
            // console.log(this.selected);
            if (this.selected.length < 2) {
                self.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '최소 한 명의 구직자를 선택해 주세요.', life: 3000 });
                this.displayResponsive = false;
                setTimeout(() => {
                    // window.location.reload();
                }, 1000);
            } else {
                // self.selectedItemss = xyz;
                // let vcheckData = {
                //     job_id: self.$route.params.id.toString(),

                //     users_id: userIds.toString(),
                // };

                // const { isInvalid, error } = ValidateSendPosition(vcheckData);
                // if (isInvalid) {
                //     self.error = error;
                //     console.log(error);
                // }
                if (userIds.length < 1) {
                    self.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '해당 구직자에게는 이미 포지션이 추천된 상태입니다. 다른 구직자를 선택해 주세요.', life: 3000 });
                    this.displayResponsive = false;
                } else {
                    {
                        return axios.post('/api/v1/admin/position-offer/send-offer', { users_id: userIds, job_id: this.$route.params.id }).then((res) => {
                            console.log(res);
                            self.$toast.add({ severity: 'success', summary: '확인.', detail: '포지션이 추천이 완료되었습니다.', life: 3000 });
                            self.openResponsive = false;
                            self.displayResponsive = false;

                            setTimeout(() => {
                                // self.openResponsive = false;
                                // self.displayResponsive = false;
                                window.location.reload();
                            }, 1000);
                        });
                    }
                }
            }
        },
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

/* .p-button {
    background: #000000;
    border: 1px solid #0a0a0a;
    color: white;
} */

.product-image {
    padding-top: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px;
    height: 100px;
    /* margin-left: 25%; */
}

i#sign {
    background: black;
    color: white;
    border-radius: 100px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

i#signs {
    background: grey;
    color: rgb(243, 235, 235);
    border-radius: 100px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}
p#modex {
    text-align: -webkit-center;
    line-height: 10px;
}
p#modex1 {
    text-align: -webkit-center;
    line-height: 20px;
}
/* button.p-button.p-component.n-wrap.p-button-outlined.p-button-info.p-mb-2.p-mr-2:hover {
    background: blue;
    color: white;
}
button.p-button.p-component.n-wrap.p-button-outlined.p-button-info.p-mb-2:hover {
    background: blue;
    color: white; */
/* } */
label#sts {
    margin-top: 10px;
}
p#round {
    border-radius: 12px;
    border: 1px solid black;
    color: black;
    display: inline-block;
    padding: 4px 15px;
}
.p-button2 {
    border: 1px solid blue;
    color: black;
    background: white;
}
button.p-button.p-component.p-button2:hover {
    background: black;
    color: white;
    border-color: black;
}
button.p-button.p-component.p-button2 {
    background: rgb(255, 253, 253);
    color: rgb(10, 10, 10);
    border: 1px solid black;
    border-color: black;
}
/* button.p-button.p-component.p-button:hover {
    background: black;
    color: white;
    border-color: black;
} */
button.p-button.p-component.p-button {
    background: rgb(255, 253, 253);
    color: rgb(10, 10, 10);
    border: 1px solid black;
    border-color: black;
}
label#fonts {
    font-weight: 550;
}
</style>
